import BackToHomePage from './BackToHomePage';
import Home from './Home';
import Snow from './Snow';

class Contact extends Home{

    constructor(props){
        super(props);
    }

    render(){
        return(
            <main>
                <div className={this.state.scale}>

                    <Snow></Snow>

                    <div className="my-14">
                        <h1 className="text-center text-white text-3xl md:text-5xl font-black"> Contacts : </h1>
                    </div>
                    <ul 
                    className="text-1xl md:text-4xl text-center m-12">
                        <li
                        className="text-white my-10">
                            <a 
                            href="https://www.linkedin.com/in/milan-marjanov-405254206/"
                            target="_blank"> 
                            LinkedIn Profile
                            </a>
                        </li>

                        <li
                        className="text-white my-10">
                            <a className="text-left"
                            href="#">
                            Email : marjanovmilan12@gmail.com
                            </a>
                        </li>

                        <li
                        className="text-white my-10">
                            <a className="text-left"
                            href="#">
                            Phone : +381645374305
                            </a>
                        </li>

                    </ul>

                    <BackToHomePage>
                    </BackToHomePage>


                </div>
            </main>
        )};
}

export default Contact;